<template>
  <!-- The full Moon that settles over the empty altar (altar redesign 2026-10-27). -->
  <svg :width="size" :height="size" viewBox="0 0 100 100" aria-hidden="true">
    <defs>
      <radialGradient :id="id" cx=".4" cy=".35" r=".75">
        <stop offset="0" stop-color="#fffaf0" /><stop offset=".7" stop-color="#f0e2bd" /><stop offset="1" stop-color="#cdb98a" />
      </radialGradient>
      <radialGradient :id="id + 'h'">
        <stop offset=".45" stop-color="#ffe7b5" stop-opacity=".45" /><stop offset="1" stop-color="#ffe7b5" stop-opacity="0" />
      </radialGradient>
    </defs>
    <circle cx="50" cy="50" r="50" :fill="`url(#${id}h)`" />
    <circle cx="50" cy="50" r="24" :fill="`url(#${id})`" />
    <circle cx="43" cy="45" r="4" fill="#d9c79c" opacity=".5" />
    <circle cx="57" cy="57" r="3" fill="#d9c79c" opacity=".45" />
  </svg>
</template>

<script setup>
defineProps({ size: { type: Number, default: 72 } })
const id = 'altar-moon-' + Math.random().toString(36).slice(2, 8)
</script>
